// import React, { useState } from 'react';
// import Layout from '../components/Layout';
// import axios from 'axios';
// import { toast, ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { Dropdown } from 'primereact/dropdown';
// import { blackListApi, blackListVisionGamesApi, DigitizeBlacklistApi, KickwinBlacklistApi, WondermindBlacklistApi } from '../Data/api';

// const Blacklist = () => {
//   const services = [
//     { name: 'kiddoCraze', code: 'KC', api: blackListApi },
//     { name: 'VisionGames', code: 'VG', api: blackListVisionGamesApi },
//     {name:'DigitizeAi',code:'DA',api: DigitizeBlacklistApi},
//     { name: "WonderMind", code: "WM", api: WondermindBlacklistApi },
//     { name: "KickWin", code: "KW", api: KickwinBlacklistApi},
//   ];

//   const [selectedService, setSelectedService] = useState('');
//   const [msisdn, setMsisdn] = useState('');
//   const [responseMessage, setResponseMessage] = useState('');

//   const handleSubmit = async () => {
//     if (!msisdn) {
//       toast.error('Please enter a valid MSISDN.');
//       return;
//     }

//     try {
//       const response = await axios.post(selectedService.api, { msisdn });
//       console.log("API Response:", response.data);

//       if (response.status === 200) {
//         if (response?.data?.error?.message) {
//           setResponseMessage(response.data.error.message);
//           toast.error(response.data.error.message);
//         } else if (response?.data?.message) {
//           setResponseMessage(response.data.message);
//           toast.success(response.data.message);
//         } else {
//           setResponseMessage("Unexpected response received.");
//         }
//       } else {
//         toast.error('Failed to blacklist the number.');
//       }
//     } catch (error) {
//       console.error("API Error:", error);
//       toast.error(error?.response?.data?.error?.message || error?.message || 'Error');
//     }
//   };

//   return (
//     <Layout>
//       <div className='flex justify-center items-center'>
//         <div className='bg-white shadow-lg rounded-lg p-8'>
//           <h1 className='text-2xl font-semibold text-gray-700 text-center mb-6'>
//             Blacklist the number
//           </h1>
//           <div className='flex flex-col items-center space-y-4'>
//             <input
//               type="number"
//               placeholder='Enter your MSISDN'
//               className='border-2 border-blue-400 rounded-md h-12 text-center px-4 w-42 focus:outline-none focus:ring-2 focus:ring-blue-500'
//               value={msisdn}
//               onChange={(e) => setMsisdn(e.target.value)}
//             />

//             <div className="card flex justify-center border-2 border-gray-200 rounded-lg w-[220px]">
//               <Dropdown
//                 value={selectedService}
//                 onChange={(e) => setSelectedService(e.value)}
//                 options={services}
//                 optionLabel="name"
//                 placeholder="Select Service"
//                 className="w-full md:w-14rem py-2"
//               />
//             </div>

//             <button
//               className='bg-red-500 hover:bg-red-600 text-white py-2 px-6 rounded-full shadow-md transition-all'
//               onClick={handleSubmit}
//             >
//               Submit
//             </button>

//             {responseMessage && (
//               <div className={`mt-4 p-3 ${responseMessage.includes("successfully") ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"} rounded-lg w-full text-center`}>
//                 {responseMessage}
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//       <ToastContainer />
//     </Layout>
//   );
// };

// export default Blacklist;

// // import React, { useState } from 'react';
// // import Layout from '../components/Layout';
// // import axios from 'axios';
// // import { toast, ToastContainer } from 'react-toastify';
// // import 'react-toastify/dist/ReactToastify.css';
// // import { Dropdown } from 'primereact/dropdown';
// // import { blackListApi, blackListVisionGamesApi } from '../Data/api';

// // const Blacklist = () => {
// //   const services = [
// //     { name: 'kiddoCraze', code: 'KC', api: blackListApi },
// //     { name: 'VisionGames', code: 'VG', api: blackListVisionGamesApi }
// //   ];
// //   const [selectedService, setSelectedService] = useState(services[0]);

// //   const [msisdn, setMsisdn] = useState('');

// //   const handleSubmit = async () => {
// //     if (!msisdn) {
// //       toast.error('Please enter a valid MSISDN.');
// //       return;
// //     }

// //     try {
// //       const response = await axios.post(selectedService.api, { msisdn });
// // console.log(response.data,"hhhhh")
// //       if (response.status === 200) {
// //         toast.success('Number successfully blacklisted!');
// //       } else {
// //         toast.error('Failed to blacklist the number.');
// //       }
// //     } catch (error) {
// //       console.log(error,"error")
// //       toast.error(error?.response?.data?.error?.message || error?.message || 'Error');
// //     }
// //   };

// //   return (
// //     <Layout>
// //       <div className='flex justify-center items-center'>
// //         <div className='bg-white shadow-lg rounded-lg p-8'>
// //           <h1 className='text-2xl font-semibold text-gray-700 text-center mb-6'>
// //             Blacklist the number
// //           </h1>
// //           <div className='flex flex-col items-center space-y-4'>
// //             <input
// //               type="number"
// //               placeholder='Enter your MSISDN'
// //               className='border-2 border-blue-400 rounded-md h-12 text-center px-4 w-42 focus:outline-none focus:ring-2 focus:ring-blue-500'
// //               value={msisdn}
// //               onChange={(e) => setMsisdn(e.target.value)}
// //             />

// //              <div className="card flex justify-center border-2 border-gray-200 rounded-lg w-[220px]">
// //                           <Dropdown
// //                             value={selectedService}
// //                             onChange={(e) => setSelectedService(e.value)}
// //                             options={services}
// //                             optionLabel="name"
// //                             placeholder="Select Service"
// //                             className="w-full md:w-14rem py-2"
// //                           />
// //                         </div>
// //             <button
// //               className='bg-red-500 hover:bg-red-600 text-white py-2 px-6 rounded-full shadow-md transition-all'
// //               onClick={handleSubmit}
// //             >
// //               Submit
// //             </button>
// //           </div>
// //         </div>
// //       </div>
// //       <ToastContainer />
// //     </Layout>
// //   );
// // };

// // export default Blacklist;

import React, { useState } from "react";
import Layout from "../components/Layout";
import axios from "axios";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Dropdown } from "primereact/dropdown";

import {
  blackListApi,
  blackListVisionGamesApi,
  DigitizeBlacklistApi,
  KickwinBlacklistApi,
  WondermindBlacklistApi,
} from "../Data/api";

const Blacklist = () => {
  const services = [
    { name: "kiddoCraze", code: "KC", api: blackListApi },
    { name: "VisionGames", code: "VG", api: blackListVisionGamesApi },
    { name: "DigitizeAi", code: "DA", api: DigitizeBlacklistApi },
    { name: "WonderMind", code: "WM", api: WondermindBlacklistApi },
    { name: "KickWin", code: "KW", api: KickwinBlacklistApi },
  ];

  const [selectedService, setSelectedService] = useState(null);

  const [msisdn, setMsisdn] = useState("");

  const [responseMessage, setResponseMessage] = useState("");

  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!msisdn) {
      toast.error("Please enter MSISDN");

      return;
    }

    if (!selectedService) {
      toast.error("Please select service");

      return;
    }

    setLoading(true);

    setResponseMessage("");

    try {
      const response = await axios.post(selectedService.api, {
        msisdn,
      });

      console.log("Blacklist Response:", response.data);

      if (response?.data?.error?.message) {
        setResponseMessage(response.data.error.message);

        toast.error(response.data.error.message);
      } else if (response?.data?.message) {
        setResponseMessage(response.data.message);

        toast.success(response.data.message);
      } else {
        setResponseMessage("Unexpected response received");
      }
    } catch (error) {
      console.log("API ERROR", error);

      toast.error(
        error?.response?.data?.error?.message ||
          error?.message ||
          "Something went wrong",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div
        className="
min-h-screen
bg-gray-50
flex
justify-center
items-start
px-4
py-10
"
      >
        <div
          className="
w-full
max-w-lg
bg-white
rounded-2xl
shadow-md
p-6
md:p-8
"
        >
          <h1
            className="
text-2xl
md:text-3xl
font-bold
text-center
text-gray-800
mb-8
"
          >
            Blacklist Number
          </h1>

          <div
            className="
flex
flex-col
items-center
gap-5
"
          >
            <input
              type="number"
              placeholder="Enter MSISDN"
              value={msisdn}
              onChange={(e) => setMsisdn(e.target.value)}
              className="
w-full
h-12
border
border-gray-300
rounded-xl
text-center
px-4
focus:outline-none
focus:ring-2
focus:ring-red-500
"
            />

            <div
              className="
w-full
"
            >
              <Dropdown
                value={selectedService}
                onChange={(e) => setSelectedService(e.value)}
                options={services}
                optionLabel="name"
                placeholder="Select Service"
                className="
w-full
border
rounded-xl
"
              />
            </div>

            <button
              onClick={handleSubmit}
              disabled={loading}
              className="
w-full
h-12
rounded-xl
bg-red-600
hover:bg-red-700
text-white
font-semibold
transition
disabled:opacity-60
"
            >
              {loading ? "Processing..." : "Submit"}
            </button>

            {responseMessage && (
              <div
                className={`
w-full
mt-4
p-3
rounded-xl
text-center
font-medium

${
  responseMessage.includes("successfully")
    ? "bg-green-100 text-green-700"
    : "bg-red-100 text-red-700"
}

`}
              >
                {responseMessage}
              </div>
            )}
          </div>
        </div>
      </div>

      <ToastContainer />
    </Layout>
  );
};

export default Blacklist;
